import { theme } from './theme'

export const tagsColor = {
  APPROVED: theme.colors.green,
  CANCELLED: theme.colors.purple,
  DONE: theme.colors.grayDark,
  ONGOING: theme.colors.green,
  REJECTED: theme.colors.red,
  WAITING_CORPS_CHIEF: theme.colors.warningOrange,
  WAITING_UNIT_COMMANDER: theme.colors.warningOrange,
  WAITING_MOUNTAIN_OFFICER: theme.colors.warningOrange,
  ALERT: theme.colors.red,
}

export const tagsCommentColor = {
  APPROVED: theme.colors.green,
  CANCELLED: theme.colors.green,
  DONE: theme.colors.green,
  ONGOING: theme.colors.green,
  REJECTED: theme.colors.red,
  WAITING_CORPS_CHIEF: theme.colors.warningOrange,
  WAITING_UNIT_COMMANDER: theme.colors.warningOrange,
  WAITING_MOUNTAIN_OFFICER: theme.colors.warningOrange,
  ALERT: theme.colors.green,
}
